import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: "AIzaSyBWL7I8psZez4rax24y-A7NnQHkPHUK1Fg",
  authDomain: "teaching-assistant-47169.firebaseapp.com",
  projectId: "teaching-assistant-47169",
  storageBucket: "teaching-assistant-47169.firebasestorage.app",
  messagingSenderId: "196526898401",
  appId: "1:196526898401:web:23c4307631acfe49314ba0",
  measurementId: "G-MVFGPB9BJC"
};

export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const analytics = getAnalytics(app);